import React, { Component } from "react";
import {
  Textbox,
  Textarea,
  Radiobox,
  Checkbox,
  Select,
  
} from "react-inputs-validation";
import axios from './../Api/MainApi';
// import "react-inputs-validation/lib/react-inputs-validation.min.css";
// import "../Other/Validation/styles_Validate.css";

import { COUNTRY_OPTIONS_LIST, JOB_OPTIONS_LIST } from "../Other/Validation/consts_Validation.js";
import logger from "../Tools/Log";
import LoadingOverlay from 'react-loading-overlay';
import ScrollAnimation from 'react-animate-on-scroll';  

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {      
      loading:false,
      id:0,
      name: "",
      email: "",
      mobile: "",
      password: "",
      password_confirmation: "",
      hasNameError: true,
      hasEmailError: true,
      hasMobileError: true,
      hasPasswordError: true,
      hasPassword_confirmationError: true,
      validate: false,
      extraValidate: false,
      error:''
    };
    this.validateForm = this.validateForm.bind(this);
  }
  
  firstLoad = true;

  
  registerUser(){
  //   console.log({
  //     Id:props.item.id,
  //     Description:State.description,
  //     Tag:State.tag,
  //     Description2:'',
  //     Date:null,
  //     Image:''
  // },'ineeee');
      // e.preventDefault();
      logger('Router>>Register>>Axios{api/accounts/create}',{
        // Id:this.state.id,
        Name:this.state.name,
        UserName:this.state.email,
        Email:this.state.email,
        PhoneNumber:this.state.mobile,
        Password:this.state.password,
        ConfirmPassword:this.state.password_confirmation,
    });
    this.setState({loading:true});  
      axios.post(`api/accounts/create`,{
          // Id:this.state.id,
          Name:this.state.name,
          UserName:this.state.email,
          Email:this.state.email,
          PhoneNumber:this.state.mobile,
          Password:this.state.password,
          ConfirmPassword:this.state.password_confirmation,
          // Address:'',
          // PostalCode:'',
          // Gender:null,
      })
      .then(Response => {
        this.setState({loading:false});  
        window.location.href = window.location.origin + '/login';
      })
      .catch(err => {
        this.setState({loading:false});  
        try {
          logger(err.response.data.modelState);
          var error =''
          if(err.response.data.modelState['createUserModel.ConfirmPassword'])
           error ='پسورد ها متفاوت هستند'
          if(err.response.data.modelState['createUserModel.Password'])
           error ='پسورد حد اقل باید 6 کاراکتر باشد'
          if(err.response.data.modelState['createUserModel.Email'])
           error = '\n\r' + error + ' ایمیل معتبر نمی باشد ';
          if(err.response.data.modelState[''])
          error = '\n\r' + error + ' این نام کاربری قبلا انتخاب شده است ';
  
          if (error !== ''){
            this.setState({error : error});
          }
        } catch (error) {
          
        }
  
      })
  }

  toggleValidating(validate) {
     this.setState({ validate });
  }

  validateForm(e) {
    e.preventDefault();
    this.toggleValidating(true);
    this.state.extraValidate = true;
    logger('Route>>Register>>validateForm>>blank>>', this.state)
    // const {
    //   hasNameError,
    //   hasMobileError,
    //   hasEmailError,
    //   hasPasswordError,
    //   hasPassword_confirmationError
    // } = this.state;
    // logger('Route>>Register>>validateForm>>',this.state)
    // if (
    //   !hasNameError &&
    //   !hasMobileError &&
    //   !hasEmailError &&
    //   !hasPasswordError &&
    //   !hasPassword_confirmationError 
    //   // !this.firstLoad 

    // ) {
      
    //   // this.registerUser()
    //   this.setState({extraValidate:true})        
    // }

    // this.firstLoad = false;
  }

  306

componentDidMount(){
  logger('ajibast');
}
  componentDidUpdate(){
    const {
      hasNameError,
      hasMobileError,
      hasEmailError,
      hasPasswordError,
      hasPassword_confirmationError,
      extraValidate
    } = this.state;

    logger('Route>>Register>>componentDidUpdate>>', this.state)
    if (
      !hasNameError &&
      !hasMobileError &&
      !hasEmailError &&
      !hasPasswordError &&
      !hasPassword_confirmationError &&
      extraValidate 
      // !this.firstLoad 

    ) {

      this.state.extraValidate = false;
      logger('Route>>Register>>componentDidUpdate>>next>>hasEmailError>>', !hasEmailError)
      logger('Route>>Register>>componentDidUpdate>>next>>extraValidate>>', extraValidate)
      this.registerUser();        
    }
    else {
      
    }
  }

  render() {
    const {
      name,
      email,
      mobile,
      password,
      password_confirmation,
      validate
    } = this.state;


    return (
      <>
            <LoadingOverlay
                active={this.state.loading}
                spinner
                text='لطفا صبور باشید...'
                >
      <div class="register_panel">
      <ScrollAnimation animateIn="fadeIn">
          <div class="container">
              <div class="register-myself" >
             
                    <form onSubmit={this.validateForm} class="form form-myself" >
                                <div class="form-body">
                                    <div class="form-group">
                                        <label class="label-control">اطلاعات کاربری</label>
                                        <div style={{color:'red', marginBottom:10}}>{this.state.error}</div>   
                                            <Textbox
                                              attributesWrapper={{}}
                                              attributesInput={{
                                                id: "Name",
                                                name: "Name",
                                                type: "text",
                                                placeholder: "نام کامل خود را وارد کنید."
                                              }}
                                              value={name} // Optional.[String].Default: "".
                                              disabled={false} // Optional.[Bool].Default: false.
                                              validate={validate} // Optional.[Bool].Default: false. If you have a submit button and trying to validate all the inputs of your form at onece, toggle it to true, then it will validate the field and pass the result via the "validationCallback" you provide.
                                              validationCallback={res =>{
                                
                                                this.setState({ hasNameError: res, validate: false })
                                                this.state.hasNameError = res
                                                this.state.validate = false;
                                                // logger('Route>>Register>>Render>>validationCallback>>name>>',res) 
                                              } 
                                              } // Optional.[Func].Default: none. Return the validation result.
                                              classNameInput="form-control" // Optional.[String].Default: "".
                                              classNameWrapper="wrapper-extra" // Optional.[String].Default: "".
                                              classNameContainer="" // Optional.[String].Default: "".
                                              customStyleInput={{}} // Optional.[Object].Default: {}.
                                              customStyleWrapper={{}} // Optional.[Object].Default: {}.
                                              customStyleContainer={{}} // Optional.[Object].Default: {}.
                                              onChange={(name, e) => {
                                                this.setState({ name:name });
                                                console.log(e);
                                              }} // Required.[Func].Default: () => {}. Will return the value.
                                              onBlur={e => {
                                                console.log(e);
                                              }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                                              // onFocus={(e) => {console.log(e);}} // Optional.[Func].Default: none.
                                              // onClick={(e) => {console.log(e);}} // Optional.[Func].Default: none.
                                              validationOption={{
                                                name: "Name", // Optional.[String].Default: "". To display in the Error message. i.e Please enter your ${name}.
                                                check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                                required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                                                // type: 'string', // Optional.[String].Default: "string". Validation type, options are ['string', 'number', 'alphanumeric', 'alpha'].
                                                // showMsg: true, // Optional.[Bool].Default: true. To determin display the error message or not.
                                                // min: 2, // Optional.[Number].Default: 0. Validation of min length when validationOption['type'] is string, min amount when validationOption['type'] is number.
                                                // max: 10, // Optional.[Number].Default: 0. Validation of max length when validationOption['type'] is string, max amount when validationOption['type'] is number.
                                                // length: 2, // Optional.[Number].Default: 0. Validation of exact length of the value.
                                                // compare: '3', // Optional.[String].Default: "" Compare this value to 3 to see if they are equal.
                                                // reg: /^\d{18}|\d{15}$/, // Optional.[Bool].Default: "" Custom regex.
                                                // regMsg: 'failed in reg.test(${value})', // Optional.[String].Default: "" Custom regex error message.
                                                // locale: 'en-US', // Optional.[String].Default: "en-US". For error message display. Current options are ['zh-CN', 'en-US']; Default is 'en-US'.
                                                msgOnError: <span class='form-error active'><strong>فیلد نام الزامی است</strong></span>, // Optional.[String].Default: "" Show your custom error message no matter what when it has error if it is provied.
                                                // msgOnSuccess: "Your custom success message if you provide the validationOption['msgOnSuccess']. Otherwise, it will not show, not even green border." // Optional.[String].Default: "". Show your custom success message no matter what when it has error if it is provied.
                                                // customFunc: res => { // Optional.[Func].Default: none. Custom function. Returns true or err message
                                                //   if (res != 'milk') {
                                                //     return 'Name cannot be other things but milk';
                                                //   }
                                                //   return true;
                                                // }
                                              }}
                                            />
                                    </div>
                                    <div class="form-group">       
                                            <Textbox
                                              attributesInput={{
                                                id: "email",
                                                name: "email",
                                                type: "text",
                                                placeholder: "ایمیل خود را وارد کنید."
                                              }}
                                              value={email} 
                                              disabled={false}
                                              validate={validate} 
                                              validationCallback={res =>
                                                {
                                               
                                                this.setState({ hasEmailError: res, validate: false })
                                                this.state.hasEmailError = res
                                                this.state.validate = false
                                                logger('Route>>Register>>Render>>validationCallback>>email>>',res)
                                                }
                                              } 
                                              classNameInput="form-control" 
                                              classNameWrapper="wrapper-extra" 
                                              onChange={(email, e) => {
                                                this.setState({ email , extraValidate:false});
                                                console.log('hiiii');
                                              }} 

                                              validationOption={{
                                                name: "email", 
                                                check: true, 
                                                required: true, 
                                                msgOnError: <span class='form-error active'><strong>فیلد ایمیل الزامی است</strong></span>, 
       
                                              }}
                                            />
                                        </div>
                                        <div class="form-group">       
                                            <Textbox
                                              attributesInput={{
                                                id: "mobile",
                                                name: "mobile",
                                                type: "text",
                                                placeholder: "شماره موبایل خود را وارد کنید."
                                              }}
                                              value={mobile} 
                                              disabled={false}
                                              validate={validate} 
                                              validationCallback={res =>{
                                                this.state.hasMobileError = res
                                                this.state.validate = false
                                                this.setState({ hasMobileError: res, validate: false })
                                              }
                                               
                                              } 
                                              // classNameInput={`form-control ${this.state.hasMobileError ? ' has-error' : ''}`}
                                              classNameInput="form-control" 
                                              classNameWrapper="wrapper-extra" 
                                              onChange={(mobile, e) => {
                                                this.setState({ mobile });
                                                console.log(e);
                                              }} 

                                              validationOption={{
                                                name: "mobile", 
                                                check: true, 
                                                required: true, 
                                                type: 'number',
                                                msgOnError: <span class='form-error active'><strong>فیلد الزامی است</strong></span>, 
       
                                              }}
                                            />
                                        </div>
                                        <div class="form-group">       
                                            <Textbox
                                              attributesInput={{
                                                id: "password",
                                                name: "password",
                                                type: "password",
                                                placeholder: "پسورد خود را وارد کنید."
                                              }}
                                              value={password} 
                                              disabled={false}
                                              validate={validate} 
                                              validationCallback={res =>{      
                                                       this.state.hasPasswordError = res
                                                this.state.validate = false
                                                this.setState({ hasPasswordError: res, validate: false })
                                              }
                                              
                                              } 
                                              classNameInput="form-control" 
                                              classNameWrapper="wrapper-extra" 
                                              onChange={(password, e) => {
                                                this.setState({ password });
                                                console.log(e);
                                              }} 

                                              validationOption={{
                                                name: "password", 
                                                check: true, 
                                                required: true, 
                                                msgOnError: <span class='form-error active'><strong>فیلد الزامی است</strong></span>, 
       
                                              }}
                                            />
                                        </div>
                                        <div class="form-group">       
                                            <Textbox
                                              attributesInput={{
                                                id: "password_confirmation",
                                                name: "password_confirmation",
                                                type: "password",
                                                placeholder: "تکرارپسورد خود را وارد کنید."
                                              }}
                                              value={password_confirmation} 
                                              disabled={false}
                                              validate={validate} 
                                              validationCallback={res =>
                                                {
                                                  this.state.hasPassword_confirmationError = res
                                                  this.state.validate = false
                                                  this.setState({ hasPassword_confirmationError: res, validate: false })
                                                }
                                               
                                              } 
                                              classNameInput="form-control" 
                                              classNameWrapper="wrapper-extra" 
                                              onChange={(password_confirmation, e) => {
                                                this.setState({ password_confirmation });
                                                console.log(e);
                                              }} 

                                              validationOption={{
                                                name: "password_confirmation", 
                                                check: true, 
                                                required: true, 
                                                msgOnError: <span class='form-error active'><strong>فیلد الزامی است</strong></span>, 
       
                                              }}
                                            />
                                        </div>
                                    <div class="form-group">
                                       <button type="submit" class="btn btn-info">عضویت</button>
                                    </div>
                                </div>
                    </form>
                 
              </div>
          </div>
          </ScrollAnimation>
      {/* </div> */}
      </div>
      </LoadingOverlay>
      </>
    );
  }
}

export default App;


